{
  "en": {
    "admin": {
      "features": {
        "title": "Feature Flags",
        "description": "Toggle feature flags for your account. Changes take effect on the next page load.",
        "search": "Search features...",
        "noResults": "No features found.",
        "activatedForYou": "Already activated for you",
        "globallyActive": "Activated for all",
        "tabsLabel": "Feature Flag Areas",
        "tabs": {
          "mine": "My Features",
          "management": "Feature Flag Management",
          "permanent": "Permanent Flags"
        }
      },
      "featureFlags": {
        "description": "Feature flags for all users – not just for your own account (unlike in the 'My Features' tab).",
        "permanentDescription": "Permanent infrastructure flags (e.g., OAuth login providers) for all users – without cleanup workflow or activation date.",
        "search": "Search flags...",
        "noResults": "No feature flags found.",
        "activatedAt": "Activated on {date}",
        "reviewWarning": {
          "title": "These feature flags should be reviewed and possibly removed:",
          "staleActivation": "activated over a week ago"
        },
        "state": {
          "on": "Activated",
          "conditional": "Conditional",
          "off": "Deactivated"
        },
        "gatesSummary": {
          "actors": "{count} user | {count} users",
          "groups": "{count} group | {count} groups",
          "percentageOfActors": "{value} % of users",
          "percentageOfTime": "{value} % of the time"
        },
        "detail": {
          "title": "Manage flag: {name}",
          "booleanSection": "Fully enabled",
          "booleanHint": "Turn the flag on or off for all users.",
          "enabledLabel": "Enabled for all",
          "actorsSection": "Individual users",
          "actorsHint": "Search and unlock users.",
          "actorsSearchLabel": "Search user",
          "actorsSearchPlaceholder": "Enter name or email...",
          "actorUnresolved": "Unknown user",
          "removeActor": "Remove",
          "groupsSection": "Groups",
          "percentageOfActorsSection": "Percentage of users",
          "percentageOfTimeSection": "Percentage of time",
          "percentageSave": "Save",
          "clearGates": "Reset all unlocks",
          "clearGatesConfirm": "Really reset all unlocks (users, groups, percentages) for \"{name}\"? This cannot be undone.",
          "clearGatesConfirmButton": "Reset",
          "clearGatesCancel": "Cancel",
          "activationSection": "Activation history",
          "activatedBy": "Enabled by {name} on {date}",
          "neverActivated": "Never fully enabled.",
          "close": "Close"
        },
        "toast": {
          "updated": "Feature flag updated.",
          "error": "Action failed. Please try again."
        }
      }
    }
  }
}
